import { FC } from 'react';

export const Incompleted: FC<any> = () => (
  <svg width={20} height={20}>
    <rect width={20} height={20} rx={4} stroke="#F2F2F2" fill="none" />
  </svg>
);
